<template>
    <keep-alive>
      <Core :token="token" :type="type" :env="env" :config="config"/>
    </keep-alive>
</template>

<script>
import Core from './components/Core'
import {mapActions} from 'vuex'

export default {
  props: ['token', 'type', 'env', 'config'],
  mounted () {
    if (this.type === 'widget' || this.type === 'frame') {
      window.EventBus.addEventListener('ss-open-selector', event => {
        this.toggleSelector()
      })
    }
  },

  methods: {
    ...mapActions(['toggleSelector']),
    toggle () {
      this.toggleSelector()
    }
  },
  name: 'App',
  components: {
    Core
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue